import { setupMFEApps } from 'lib/SetupMFEApps'
;(async () => {
  await setupMFEApps()
  import('./bootstrap')
})()
